import React from 'react'
import { Form, InputNumber } from 'antd'

export const FormNumberInput = ({
  editable,
  name,
  message,
  initialValue = '',
  width = '100%',
  required = false,
  ...others
}) => {
  if (!editable) return initialValue
  return (
    <Form.Item name={name} noStyle rules={[{ required: required, message: { message } }]}>
      <InputNumber style={{ width: width }} {...others} />
    </Form.Item>
  )
}
